export default __webpack_public_path__ + "static/media/arrow-left.3d231fb3.svg";